import(/* webpackMode: "eager" */ "/home/ubuntu/download_staging/6a60002199f1da0014a9c346_1787681409980_2703cbf1/nautex/src/app/page.tsx");
